import { render, staticRenderFns } from "./TicketCorteDeCaja.vue?vue&type=template&id=bef0b7f6&scoped=true&"
import script from "./TicketCorteDeCaja.vue?vue&type=script&lang=js&"
export * from "./TicketCorteDeCaja.vue?vue&type=script&lang=js&"
import style0 from "./TicketCorteDeCaja.vue?vue&type=style&index=0&id=bef0b7f6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef0b7f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
